"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

type Session = {
  token: string | null;
  slug: string | null;
  setAuth: (token: string, slug: string) => void;
  clear: () => void;
};

export const useSession = create<Session>()(
  persist(
    (set) => ({
      token: null,
      slug: null,
      setAuth: (token, slug) => set({ token, slug }),
      clear: () => set({ token: null, slug: null }),
    }),
    { name: "cooking-with-friends", skipHydration: true },
  ),
);
